const fragment = `
  id
  imageUrl
`;

export const listUnitImagesQuery = `
  query ListUnitImages(
    $filter: UnitImageFilterInput
  ) {
    items: listUnitImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createUnitImageQuery = `
  mutation CreateUnitImage(
    $input: CreateUnitImageInput!
    $image: Upload
  ) {
    item: createUnitImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateUnitImageQuery = `
  mutation UpdateUnitImage(
    $input: UpdateUnitImageInput!
    $image: Upload
  ) {
    item: updateUnitImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteUnitImageQuery = `
  mutation DeleteUnitImage(
    $id: Int!
  ) {
    item: deleteUnitImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortUnitImagesQuery = `
  mutation SortUnitImages(
    $unitId: Int!,
    $ids: [Int!]!
  ) {
    items: sortUnitImages(unitId: $unitId, ids: $ids) {
      id
    }
  }
`;
